import { useMemo } from 'react';

import { Application } from '@widgets/cabinet/applicationCard/types';
import { Shop, useIntegrationConfigs } from '@hooks/useIntegrationConfigs';

import { HowToHelpType } from '@shared/enums';

export function useApplicationShop(application: Application, category: HowToHelpType): Shop | null {
  const integrationConfigs = useIntegrationConfigs();

  return useMemo(() => {
    const integration = integrationConfigs.find((integration) => integration.type === category);
    if (!application.shops || !integration) {
      return null;
    }

    const shop = application.shops.find((shop) => shop.type === category) || null;

    return integration.shops.find((integrationShop) => shop?.name === integrationShop.name) || null;
  }, [integrationConfigs, category]);
}
